export default __webpack_public_path__ + "static/media/FurnitureItem10.7af6cfca.png";